import { lazy } from 'react';

const TimeSheet = lazy(() => import('./TimeSheet'));

export default TimeSheet;
